import React from "react";

const LABELS = ["Too short", "Weak", "Fair", "Strong", "Very strong"];
const COLORS = ["bg-zinc-700", "bg-red-500", "bg-amber-500", "bg-emerald-500", "bg-emerald-400"];
const WEAK_STARTS = /^(?:password|passphrase|qwerty|123456|letmein|admin|welcome|iloveyou)/i;

const BONUS_RULES = [
  (pw) => pw.length >= 14,
  (pw) => pw.length >= 20,
  (pw) => /[a-z]/.test(pw) && /[A-Z]/.test(pw),
  (pw) => /\d/.test(pw),
  (pw) => /[^A-Za-z0-9]/.test(pw),
  (pw) => pw.trim().split(/\s+/).length >= 4,
];
const PENALTY_RULES = [(pw) => /(.)\1{2,}/.test(pw), (pw) => WEAK_STARTS.test(pw)];
const SCORE_BANDS = [[2, 1], [4, 2], [5, 3]]; // [max raw, score]; above the last band → 4

export function scorePassword(pw) {
  if (!pw || pw.length < 10) return { score: 0, label: LABELS[0] };
  const raw = 1 + BONUS_RULES.filter((r) => r(pw)).length - (PENALTY_RULES.some((r) => r(pw)) ? 2 : 0);
  const score = (SCORE_BANDS.find(([max]) => raw <= max) || [null, 4])[1];
  return { score, label: LABELS[score] };
}

export function StrengthMeter({ password }) {
  const { score, label } = scorePassword(password);
  return (
    <div data-testid="password-strength" data-score={score} className="mt-2">
      <div className="flex gap-1">
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className={`h-1 flex-1 rounded-sm transition-colors duration-300 ${i <= score ? COLORS[score] : "bg-zinc-800"}`}
          />
        ))}
      </div>
      <div className="mt-1 flex justify-between text-[10px] uppercase tracking-widest font-mono">
        <span className={score >= 3 ? "text-emerald-400" : score === 2 ? "text-amber-400" : score === 1 ? "text-red-400" : "text-zinc-500"}>
          {password ? label : "min 10 characters"}
        </span>
        <span className="text-zinc-600">{password.length} chars</span>
      </div>
    </div>
  );
}
